// extracted by mini-css-extract-plugin
export default {"icon":"_1Tpfm3mba6E4pRLIeTq1mF","right":"VLPL0tGax8FP-TGDStixt","left":"_2_9HefVSnuK6AzhxeJHJkE","spin":"_1pMtdm17fQkW4h9lo02wau","pulse":"pW0_8SB7XzMMx9HCgo4gM"};